// extracted by mini-css-extract-plugin
module.exports = {"CollectionTags":"styles_CollectionTags__h6xhV"};